import { useEffect, useState } from 'react';
import { io, Socket } from 'socket.io-client';

export interface SyncStatus {
  isActive: boolean;
  currentChild?: string;
  message?: string;
  lastCompleted?: Date;
  error?: string;
}

const API_URL = import.meta.env.VITE_API_URL || '/api';
const SOCKET_URL = API_URL.replace('/api', '');

export function useSyncStatus() {
  const [socket, setSocket] = useState<Socket | null>(null);
  const [syncStatus, setSyncStatus] = useState<SyncStatus>({
    isActive: false,
  });

  useEffect(() => {
    // Connect to Socket.io server
    const newSocket = io(SOCKET_URL, {
      transports: ['websocket', 'polling'],
    });

    newSocket.on('connect', () => {
      console.log('WebSocket connected');
    });

    newSocket.on('disconnect', () => {
      console.log('WebSocket disconnected');
    });

    // Listen for sync events
    newSocket.on('sync:started', () => {
      setSyncStatus({
        isActive: true,
        message: 'Starting homework sync...',
      });
    });

    newSocket.on('sync:progress', (data: { child: string; status: string; message: string }) => {
      setSyncStatus({
        isActive: true,
        currentChild: data.child,
        message: data.message,
      });
    });

    newSocket.on('sync:completed', (data: { timestamp: string; homeworkCount: number }) => {
      setSyncStatus({
        isActive: false,
        lastCompleted: new Date(data.timestamp),
        message: `Sync completed - ${data.homeworkCount} homework items`,
      });
    });

    newSocket.on('sync:error', (data: { timestamp: string; error: string }) => {
      setSyncStatus({
        isActive: false,
        error: data.error,
        message: `Sync failed: ${data.error}`,
      });
    });

    setSocket(newSocket);

    // Cleanup on unmount
    return () => {
      newSocket.close();
    };
  }, []);

  return { syncStatus, socket };
}
